//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;

autoplayManager.containerName = "autoplayContainer:autoplayBackground";

Loader.initialise = function (container) {
  Loader.container = container;

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler("ready", Loader.onLayoutComplete);
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === "loading") {
    Loader.progressBar = resourceManager.get("loader:loadingProgressBack");
    Loader.setLoadProgress(0);
    resourceManager.getContainer("loadingContainer").visible = true;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("minerContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("fsBackgroundContainer").visible = false;
    resourceManager.getContainer("darkOverlayContainer").visible = true;

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo)
      ? loadingData.gamCareLogo
      : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get("GamCareContainerPreLoad:gamCareLogo").visible =
      isGamCareLogoVisible;
    resourceManager
      .get("GamCareContainerPreLoad:preLoadMessage")
      .setText(isPreloadMessageVisible ? loadingData.message : "");
    resourceManager.get("GamCareContainerPreLoad").visible =
      isGamCareLogoVisible ||
      (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== "loading") {
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  gameData.winningsMeterTitle = resourceManager.get(
    "meterContainer:winnings:title"
  );
  gameData.screenDim = resourceManager.get("backgroundScreenDimObject");
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];
  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController("inputOverlord");
  gameData.inputOverlord.setState("disabled");
  gameData.slotConfig = gameConfigTask.data.slotConfig;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (
      element
    ) {
      return element.name === "encore";
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get(
      "buttonContainer:buttonBar:luckyBetToggleButton"
    );

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager
      .getController("stakeController")
      .setStakeMultiplier(encoreData.value);
    game.changeStake(
      resourceManager.getController("stakeController").CurrentStake
    );
    game.resetWinnings();
    resourceManager.getController("stakeController").broadcastCurrentStake();
  }

  game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
  game.loadingBackgroundLandscape.setInteractiveCallbacks(
    gdk.loadingClosed,
    true
  );

  game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
  game.loadingBackgroundPortrait.setInteractiveCallbacks(
    gdk.loadingClosed,
    true
  );

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  game.stopDistances = gameConfigTask.data.stopDistances;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
  for (var i = 0; i < slotMachine.reels.length; i++) {
    let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
    let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

    // Copy starting symbols from server
    for (var j = 0; j < reelLength; ++j) {
      reel.setReelSymbol(j, startingSymbols[j].value);
    }

    // using a closure to pass through the correct reelID
    reel.spinCompleteCallback = (function () {
      var reelID = i;
      return function () {
        if (freespins.inFreespins) {
          freespins.onSpinCompleteFS(reelID);
        } else {
          gameController.onSpinCompleteBase(reelID);
        }
      };
    })();

    reel.initialDropCompleteCallback = (function () {
      var reelID = i;
      return function () {
        if (freespins.inFreespins) {
          freespins.initialDropComplete(reelID);
        } else {
          gameController.initialDropComplete(reelID);
        }
      };
    })();

    gameData.reels.push(reel);
    gameData.reelAnimations.push(
      resourceManager.get(
        "slotContainer:reelContainer:reel" +
          i +
          ":animationStripContainer:" +
          "reelAnimStrip" +
          i
      )
    );
  }

  Loader.readyForSplash = true;
  Loader.checkCanGoToSplash();

  Reflex.deregisterEventHandler("ready", Loader.onLayoutComplete);
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    resourceManager.getContainer("loadingContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = true;
    game.goToSplash();
  }
};

Loader.setLoadProgress = function (percent) {
  var width = Loader.progressBar.texture.baseTexture.width * percent;
  Loader.progressBar.texture.frame = new PIXI.Rectangle(
    0,
    0,
    width,
    Loader.progressBar.texture.baseTexture.height
  );
};

messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);
